import * as React from 'react';

import { Disclosure } from '@headlessui/react';
import { classNames } from '../../utils';

const Accordion = ({ title, description, items }) => {
  return (
    <div className="col-span-12 accordion mx-auto">
      {title && <h3 className="title">{title}</h3>}
      {items.map((item) => (
        <Disclosure key={item.title}>
          {({ open }) => (
            <>
              <Disclosure.Button className={classNames('accordion-button', open ? 'expanded' : '')}>
                <span className="accordion-icon"></span>
                <h3>{item.title}</h3>
              </Disclosure.Button>
              <Disclosure.Panel className="accordion-panel ">
                <div className="flex flex-col justify-center items-start w-full" key={item.title}>
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
      {description && (
        <div className="accordion-description" dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </div>
  );
};

export default Accordion;
